import React from "react";
import { Flame } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useWeeklyStreak } from "@/hooks/useWeeklyStreak";

const DAY_LABELS = ["M", "T", "W", "T", "F", "S", "S"];

export const StreakPillButton: React.FC = () => {
  const { studiedDays, count, goal } = useWeeklyStreak();

  return (
    <div className="hidden md:block">
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex h-10 items-center gap-1 rounded-full border border-amber-500/20 bg-amber-500/5 pl-2.5 pr-3 text-sm transition-colors hover:border-amber-500/30 hover:bg-amber-500/10"
          >
            <Flame className="h-4 w-4 text-amber-500" aria-hidden="true" />
            <span className="font-medium text-amber-600 dark:text-amber-400">
              {count}/{goal}
            </span>
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="end"
          sideOffset={8}
          className="w-auto min-w-[270px] rounded-2xl p-4"
        >
          <div className="mb-1 flex flex-col items-start">
            <div className="flex w-full items-center justify-start gap-2">
              <Flame className="h-8 w-8 text-amber-500" aria-hidden="true" />
              <p className="text-3xl font-medium leading-none text-amber-500">
                {count}/{goal}
              </p>
            </div>
            <p className="mt-2 text-lg font-medium text-foreground">This Week</p>
          </div>
          <div className="mb-3 flex items-center gap-2">
            <p className="text-xs text-muted-foreground">
              Study {goal} days this week to start your streak.
            </p>
            <span className="inline-flex items-center rounded-full bg-primary/5 px-2 py-0.5 text-[11px] font-semibold text-muted-foreground dark:bg-primary/10">
              {count}/{goal}
            </span>
          </div>
          <div className="grid grid-cols-7 gap-1.5 rounded-[1.25rem] border border-transparent bg-transparent p-0">
            {DAY_LABELS.map((label, i) => {
              const studied = studiedDays.has(i);
              return (
                <div key={i} className="flex flex-col items-center gap-1">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-full border transition-colors ${
                      studied
                        ? "border-amber-500/30 bg-amber-500/10"
                        : "border-transparent bg-primary/5 text-muted-foreground dark:bg-primary/10"
                    }`}
                  >
                    <span
                      className={`h-2.5 w-2.5 rounded-full ${
                        studied ? "bg-amber-500" : "bg-muted-foreground/50"
                      }`}
                    />
                  </div>
                  <div className="text-[11px] font-semibold text-muted-foreground">
                    {label}
                  </div>
                </div>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
